var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"line-left mb-3"},[_c('b',[_vm._v(" "+_vm._s(_vm.$t('blog.popularTags')))])]),_c('br'),_vm._l((_vm.TagsButton),function(item){return _c('button',{key:item.id,staticClass:"btn-sm btn-light-secondary m-1 btn-pill"},[_vm._v(" "+_vm._s(item.text)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }